import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { DOMHitTest } from "../../../library-js/dom-tools/DOMHitTest";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnMouseEnter, OnMouseLeave, OnMouseMove } from "../../../library-js/dom-tools/EventListeners";
import { InputManager } from "../../../library-js/dom-tools/InputManager";
import { DOMOrientation } from "../../../library-js/dom/DOMOrientation";
import { Rokojori } from "../Rokojori";

export class MediaGallery
{
  private static videoElements:HTMLElement[];
  private static activeVideoElement:HTMLElement;
  private static attachedGlobalListeners = false;
  

  static readonly mediaVideo = new ElementType( "media-video" );
  static readonly activeFlag = new ClassFlag( "active-video" );

  static applyOnDocument()
  {
    this.attachGlobalListener();

    MediaGallery.videoElements = MediaGallery.mediaVideo.queryAll( document.body ) as HTMLElement[];

    MediaGallery.videoElements.forEach( v => this.applyOnVideoElement( v ) );
  }

  static attachGlobalListener()
  {
    if ( MediaGallery.attachedGlobalListeners )
    {
      return;
    } 

    MediaGallery.attachedGlobalListeners = true;

    OnMouseMove.add(
      document.body, 
      ( e )=>
      {

        if ( DOMOrientation.isPortrait )
        {
          return;
        }

        if ( ! MediaGallery.activeVideoElement )
        {
          return;
        }

        let isOver = DOMHitTest.isPointerOver( e, MediaGallery.activeVideoElement );
        
        if ( isOver )
        {
          console.log( "MOUSE OVER" );
          return;
        }

        let rel = DOMHitTest.getNormalizedPointerPosition( e, MediaGallery.activeVideoElement );
        let rect = DOMHitTest.getPageRect( MediaGallery.activeVideoElement );
        

        console.log( "ACTIVE NOT MOUSE OVER:", MediaGallery.activeVideoElement  );
        console.log( `Relative Position ${rel.x},${rel.y}` );
        console.log( e.pageX, e.pageY, rect );
        MediaGallery.updateActiveVideo( null );
        
      }
    )
  }

  static applyOnVideoElement( e:Element )
  {
    OnMouseEnter.add( e as HTMLElement, 
      ()=>
      {
        if ( DOMOrientation.isPortrait )
        {
          return;
        }

        MediaGallery.updateActiveVideo( e );
      }
    );

    Rokojori.$.insight.onInsight( e, 
      ()=>
      {
        if ( DOMOrientation.isLandscape )
        {
          return;
        }

        MediaGallery.updateActiveVideo( e ); 
      } 
    )

    Rokojori.$.insight.onOffsight( e, 
      ()=>
      {

        if ( DOMOrientation.isLandscape )
        {
          return;
        }


        if ( MediaGallery.activeVideoElement !== e )
        {
          return;
        }

        MediaGallery.updateActiveVideo( null ); 
      } 
    )
  }

  static updateActiveVideo( e:Element )
  {
    MediaGallery.activeVideoElement = e as HTMLElement;

    console.log( "SET ACTIVE VIDEO:", e );

    this.videoElements.forEach(
      ( v )=>
      {
        let isActive = MediaGallery.activeVideoElement === v;
        this.activeFlag.setAs( v, isActive );

        let video = ElementType.video.query( v );
        
        if ( ! video )
        {
          console.log( "No video" );
          return;
        }

        if ( video.paused === ! isActive )
        {
          console.log( "video.paused === ! isActive" );
          return;
        }

        if ( isActive )
        {
          console.log( "Requested video playing" );
          video.currentTime = 0;
          video.play();
        }
        else
        {
          console.log( "Requested video pause" );
          video.pause();
        }

      }
    )
  }
}